var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-item-icon"},[(_vm.itemIconType === 'picture')?[_c('img',{attrs:{"src":_vm.itemIconValue}})]:[_c('span',[_vm._v(_vm._s(_vm.itemIconValue))])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }